export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    const A = a[key]
    const B = b[key]

    return (order.indexOf(A) > order.indexOf(B)) ? 1 : -1
  })
  return array
}
